document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.mobile-accordion');
  if (!container) return;

  const formatter = container.querySelector('rte-formatter');
  if (!formatter) return;

  let isAccordionActive = false;
  let toggleButton = null;
  let contentWrapper = null;

  function enableAccordion() {
    if (isAccordionActive) return;

    const header = formatter.querySelector('h3');
    if (!header) return;

    // Create button
    toggleButton = document.createElement('button');
    toggleButton.className = 'accordion-toggle';
    toggleButton.innerHTML = header.innerHTML;

    const existingMinusIcon = document.querySelector('.menu__heading__toggle.svg-wrapper.icon-minus').cloneNode(true);
    const minusIconElement = document.createElement('span');
    minusIconElement.className = 'accordion-toggle__icon minus-icon';
    minusIconElement.append(existingMinusIcon);
    toggleButton.appendChild(minusIconElement);

    const existingPlusIcon = document.querySelector('.menu__heading__toggle.svg-wrapper.icon-plus').cloneNode(true);
    const plusIconElement = document.createElement('span');
    plusIconElement.className = 'accordion-toggle__icon minus-icon';
    plusIconElement.append(existingPlusIcon);
    toggleButton.appendChild(plusIconElement);

    // Create content wrapper
    contentWrapper = document.createElement('div');
    contentWrapper.className = 'accordion-content';

    // Move everything after <h3> into the content wrapper
    let node = header.nextSibling;
    while (node) {
      const next = node.nextSibling;
      contentWrapper.appendChild(node);
      node = next;
    }

    // Replace header with button and add content
    formatter.replaceChild(toggleButton, header);
    formatter.appendChild(contentWrapper);

    // Add toggle behavior
    toggleButton.addEventListener('click', () => {
      contentWrapper.classList.toggle('open');
    });

    isAccordionActive = true;
  }

  function disableAccordion() {
    if (!isAccordionActive || !toggleButton || !contentWrapper) return;

    // Restore original header
    const originalHeader = document.createElement('h3');
    originalHeader.innerHTML = toggleButton.innerHTML;

    formatter.replaceChild(originalHeader, toggleButton);

    // Move all content back before removing wrapper
    while (contentWrapper.firstChild) {
      formatter.appendChild(contentWrapper.firstChild);
    }
    contentWrapper.remove();

    // Clean up references
    toggleButton = null;
    contentWrapper = null;
    isAccordionActive = false;
  }

  function checkWidthAndUpdate() {
    if (window.innerWidth < 750) {
      enableAccordion();
    } else {
      disableAccordion();
    }
  }

  // Initial check
  checkWidthAndUpdate();

  // Watch for resize changes
  window.addEventListener('resize', checkWidthAndUpdate);
});
